import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-light text-white py-1 mt-5 border-top">
      <Container>
        <Row className="text-center align-items-center">
          <Col>
            <small>&copy; 2025 Shruti Shah & Co. | All Rights Reserved |
              <Link to="/" className="text-white text-decoration-none ms-2">Home</Link> |
              <Link to="/about" className="text-white text-decoration-none">About</Link> |
              <Link to="/services" className="text-white text-decoration-none">Services</Link> |
              <Link to="/contact" className="text-white text-decoration-none">Contact</Link>
            </small>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
